<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Regroupement</h2>
    </div>
  </div>
  <div class="row">
      <div class="col">
          <div class="row">
            <div class="col-4 lbl">
                <label>Nom :</label>
            </div>
            <div class="col-4">
                <InputText v-model="regroupement.description"/>
            </div>
          </div>
          <div class="row">
            <div class="col-4 lbl">
                <label>Secteur :</label>
            </div>
            <div class="col-4">
                <Dropdown v-model="regroupement.secteur" :options="secteurLibelles" optionValue="valeur" optionLabel="texte"
                    scrollHeight="205px" :showClear="true"/>
            </div>
          </div>
          <div class="row">
            <div class="col-4 lbl">
                <label>Quota :</label>
            </div>
            <div class="col-4">
                <InputText type="number" v-model="regroupement.quota"/>
            </div>
          </div>
          <div class="row">
            <div class="col-4 lbl">
                <label>Quota minimum :</label>
            </div>
            <div class="col-4">
                <InputText type="number" v-model="regroupement.quotaMin"/>
            </div>
          </div>
      </div>
  </div>
  <div class="row">
    <div v-if="isSauvegardeEnCours" class="col">
      <vue-loaders name="ball-beat"></vue-loaders>
    </div>
    <div v-else class="col">
      <Button @click="sauvegarder"> Sauvegarder </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter Regroupement");  
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
      .then((res) => {
        this.secteurLibelles = res.data.entiteDecision.secteur.libelles;
      });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      regroupement: {},
      secteurLibelles: [],
      isSauvegardeEnCours: false,
    }
  },
  methods: {
    sauvegarder(){
      this.isSauvegardeEnCours = true;
      this.$store.dispatch('pilotage/ajouterRegroupementAction', {regroupement: this.regroupement}).then(() => {
        this.isSauvegardeEnCours = false;
        this.$toast.add({
          severity:'success',
          summary: 'Ajout Regroupement',
          detail:"L'ajout a été effectué",
          life: 6000
        });
      });
    },
    fermer(){
        this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
